export function leadsStartingState(props) {
  return {
    availableDatabaseOptions: props.availableDatabaseOptions,
    currentUser: props.currentUser,
    features: {
      projectTasksActivities: false,
      clientReport: false,
      addLeadsToLists: !!props.addLeadsToLists,
    },
    leads: { fetching: true },
    leadsOptions: {
      selectOptions: {
        referralSources: props.leadReferralSources,
        statuses: props.leadStatuses
      }
    },
    project: props.project,
    session: {
      currentColumns: null,
      currentCompanyColumns: null,
      currentPersonColumns: null
    },
    tasks: { fetching: true },
    leadShow: {
      isCaUploading: false
    }
  };
}
